<p class="fms-notification-title" *ngIf="title">{{ title }}</p>
<p class="fms-notification-body" *ngIf="body">{{ body }}</p>
<button vng-button variant="outline" size="sm" type="button" (click)="open()">{{ label }}</button>
